import ButtonCircle from "../../../../shared/components/button_circle"
import ButtonBig from "../../../../shared/components/button_big"
import { useEffect, useState } from 'react';
import { MultiPositionSwitch } from "../../../../shared/components/MultiPositionSwitch";


export const CartsList = ({ carts, activeFieldForActivities, onChangeActivitiesField, onClickViewCart }: { carts: any[], activeFieldForActivities: any, onChangeActivitiesField: any, onClickViewCart: any }) => {

    const [showModifyNameModal, setShowModifyNameModal] = useState(false)

    const [activeItem, setActiveItem] = useState<any>(null)

    const [newValue, setNewValue] = useState("")

    const [filterCards, setFilterCards] = useState<any[]>([])

    const [cartaFilter, setCartaFilter] = useState("All")

    useEffect(() => {

        let filteredCarts = cartaFilter==="All" ? carts : carts.filter(c => c.haveActivity === (cartaFilter === 'Si'))

        setFilterCards(filteredCarts)


    }, [carts,cartaFilter])
    

    const onClickChangeLocation = (c: any) => {
        setShowModifyNameModal(true)
        setActiveItem(c)
        setNewValue(c.locationCart)
    }

    const onChageLocationName = () => {
        const cleanValue = newValue?.replace(activeFieldForActivities, '').trim()
        const preValue = activeItem?.locationCart?.replace(activeFieldForActivities, '').trim()
        onChangeActivitiesField('location', preValue, cleanValue)
        setShowModifyNameModal(false)
    }

    const onChangeSwitch = (e: any) => {
        setCartaFilter(e)
    }


    return (
        <>
            {/* Modal */}
            {showModifyNameModal &&
                <div className='consolidate_files_container_modal_edit_container'>
                    <div className="consolidate_files_container_modal_edit_container_input_container" >
                        <div className="consolidate_files_container_header">
                            <div>Modificar Locacion Carta</div>
                            <ButtonCircle icon="/assets/icons/close.svg" iconHeight={15} iconWidth={15} onClick={() => setShowModifyNameModal(false)} />
                        </div>
                        <div className="consolidate_files_container_body">
                            <div className="consolidate_files_container_custom_input">
                                <label htmlFor="file">Valor Actual : </label>
                                <div className="consolidate_files_container_custom_input_value">{activeItem?.locationCart}</div>
                            </div>
                            <div className="consolidate_files_container_custom_input">
                                <label htmlFor="file">Nuevo Valor </label>
                                <input type="text" value={newValue} onChange={(e) => setNewValue(e.target.value)} className="consolidate_files_container_input" />
                            </div>
                            <ButtonBig text='Guardar Cambios' onClick={() => onChageLocationName()} />
                        </div>
                    </div>
                </div>}
            <div className="consolidate_files_container_cuadrillas_container">
                <div className="consolidate_files_container_table_custom_filter">
                    <div></div>
                    <div>
                        <MultiPositionSwitch value={cartaFilter} label="Actividad" options={['All', 'Si', 'No']} onChange={onChangeSwitch} />
                    </div>
                </div>
                <div className='consolidate_files_container_table_container'>
                    <div className={`consolidate_files_container_table_header`}>
                        <div>Locacion Carta</div>
                        <div>Pozo</div>
                        <div>Origen</div>
                        <div></div>
                        <div />
                    </div>
                    <div className="consolidate_files_container_table_info_container">
                        {filterCards.map((c, i) => (
                            <div key={i} className={`consolidate_files_container_table_row ${!c.haveActivity && 'consolidate_files_container_alert_row'}`}>
                                <div>{c.locationCart}</div>
                                <div>{c.LocationActivity}</div>
                                <div>{c.source}</div>
                                <div className="consolidate_files_container_table_row_buttons">
                                    {/* <ButtonBig text='Ver Variables' onClick={() => onClickViewVariables(c)} /> */}
                                    <ButtonBig text='Ver Detalles' onClick={() => onClickViewCart(c)} />
                                    <ButtonBig text='Modificar Locacion' onClick={() => onClickChangeLocation(c)} />
                                </div>
                            </div>
                        )
                        )}
                    </div>
                </div>
            </div>
        </>
    )
}